// Copyright (c) 2017 Deere & Company

import AuditStatusReport from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.reports.auditStatus
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(AuditStatusReport);



// WEBPACK FOOTER //
// ./src/reports/audit-status/state-connector.js